<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<mat-form-field appearance="outline">
    <mat-label *ngIf="label?.length > 0">{{label}}</mat-label>
    <mat-select [disabled]="disabled" id="language-select" name="language-select" aria-label="Select Language"
            [(ngModel)]="selectedLanguage" [disableOptionCentering]="true" (selectionChange)="onLanguageSelectChanged($event)">
        <mat-option *ngFor="let language of supportedLanguages" id="lang-{{language.code}}" [value]="language.code">
            {{language.name}}
        </mat-option>
    </mat-select>
</mat-form-field>
